import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as actions from '../../store/actions/dataExport'
import { getDataExportList, getIsFetching } from '../../store/reducers/dataExport'
import DataExportList from './DataExportList'
import LoadingSpinner from '../loadingSpinner'
import CreateDataExport from '../dataExport/dialogs/CreateDataExport.dialog'
import UpdateDataExport from './dialogs/UpdateDataExport.dialog'
import EraseDataExport from '../dataExport/dialogs/EraseDataExport.dialog'
import ResendDataExportKey from '../dataExport/dialogs/ResendDataExportKey.dialog'
import ListPagination from '../styles/ListPagination'

const DataExport = () => {
  const dispatch = useDispatch()
  const dataExportList = useSelector(getDataExportList)
  const isFetching = useSelector(getIsFetching)

  const fetchDataExportList = (params) => dispatch(actions.fetchDataExportList(params))

  const handlePageChange = (pageNumber) => {
    fetchList(pageNumber)
  }

  const fetchList = (pageIndex) => {
    const pageIndexZeroBased = pageIndex - 1
    fetchDataExportList({ pageIndex: pageIndexZeroBased })
  }

  const onActionComplete = () => {
    fetchDataExportList()
  }

  const onActionCompleteNoPageChange = () => {
    fetchDataExportList({ pageIndex: dataExportList.pageIndex })
  }

  return (
    <>
      <CreateDataExport onComplete={onActionComplete} />
      <UpdateDataExport onComplete={onActionCompleteNoPageChange} />
      <EraseDataExport onComplete={onActionCompleteNoPageChange} />
      <ResendDataExportKey onComplete={onActionCompleteNoPageChange} />
      <DataExportList />
      <ListPagination list={dataExportList} handlePageChange={handlePageChange} />
      {isFetching && !dataExportList.length && <LoadingSpinner loading={isFetching} message={'Hämtar data exporter'} />}
    </>
  )
}

export default DataExport
